import { useBaseQuery } from '@aibees/shared/http/hooks';
import {
  NotificationCountResponse,
  NotificationMessageChannel,
  NotificationMessageGroup,
  NotificationStatus,
} from '../types';
import { NOTIFICATION_API_PREFIX } from './constants';

export function useBrowseNotificationsCountApi(statuses?: NotificationStatus) {
  const params = {
    return: 'count',
    groups: `${NotificationMessageGroup.EVENT},${NotificationMessageGroup.UPDATE}`,
    channels: NotificationMessageChannel.NOTIFICATION,
    statuses,
  };
  return useBaseQuery<typeof params, NotificationCountResponse[]>(
    [useBrowseNotificationsCountApi.name, statuses],
    {
      url: NOTIFICATION_API_PREFIX,
      params,
    }
  );
}
